// Industry types for company onboarding
// Based on NAICS (North American Industry Classification System) simplified for small businesses

export const INDUSTRY_TYPES = [
  { value: 'general_business', label: 'General Business' },
  { value: 'restaurant', label: 'Restaurant & Food Service' },
  { value: 'retail', label: 'Retail & E-commerce' },
  { value: 'professional_services', label: 'Professional Services' },
  { value: 'healthcare', label: 'Healthcare & Medical' },
  { value: 'construction', label: 'Construction & Trades' },
  { value: 'automotive', label: 'Automotive Services' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'fitness_wellness', label: 'Fitness & Wellness' },
  { value: 'beauty_salon', label: 'Beauty & Personal Care' },
  { value: 'education', label: 'Education & Training' },
  { value: 'nonprofit', label: 'Non-Profit Organization' },
  { value: 'technology', label: 'Technology & Software' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'transportation', label: 'Transportation & Logistics' }
];

export default INDUSTRY_TYPES;